import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const ReservationError = ({ errors }) => {
  if (!errors || Object.keys(errors).length < 1) {
    return null;
  }

  return (
    <div className="alert alert-danger">
      <ul>
        {Object.keys(errors).map(key => (
          <li key={key}>{errors[key]}</li>
        ))}
      </ul>
    </div>
  );
};

const mapStateToProps = state => ({
  errors: state.reservation.errors,
});

ReservationError.propTypes = {
  errors: PropTypes.object
};

export default connect(mapStateToProps)(ReservationError);
